// Contextual suggested questions for the help assistant, keyed by route
// prefix. First match wins; 'default' is the fallback. Deterministic config —
// no AI involved in picking chips (same approach as Stripe's assistant).

const SUGGESTIONS: { prefix: string; questions: string[] }[] = [
  {
    prefix: '/admin/dashboard',
    questions: [
      'How is my organization doing this month?',
      'What do the dashboard numbers mean?',
      'How do I open a new registration?',
    ],
  },
  {
    prefix: '/admin/registration',
    questions: [
      'How does the waitlist work?',
      'How do I set up early-bird pricing?',
    ],
  },
  {
    prefix: '/admin/organize',
    questions: [
      'How many spots are left in my divisions?',
      'How do I cap the number of teams in a division?',
      'How does the config hierarchy work?',
    ],
  },
  {
    prefix: '/admin/transactions',
    questions: [
      'How do refunds work?',
      'What fees does Staty charge?',
      'Show me my recent payments',
    ],
  },
  {
    prefix: '/admin/game-results',
    questions: [
      'How does scoresheet scanning work?',
      'How do I enter game stats?',
    ],
  },
  {
    prefix: '/admin/settings',
    questions: [
      'How do I set up payments?',
      'How do I hide statistics from the public site?',
    ],
  },
];

const DEFAULT_QUESTIONS = [
  'How do I open a registration?',
  'How do I set up payments?',
  'Show me a summary of my organization',
];

export function getSuggestions(pathname: string): string[] {
  const match = SUGGESTIONS.find((s) => pathname.startsWith(s.prefix));
  return match ? match.questions : DEFAULT_QUESTIONS;
}
